import { render, staticRenderFns } from "./ReferansTypes.vue?vue&type=template&id=7014f05e&"
import script from "./ReferansTypes.vue?vue&type=script&lang=js&"
export * from "./ReferansTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports